// Entry point for the "post" bundle.
//
// This module sets up event listeners for user interactions (Enter key, chip clicks),
// handles dark mode detection, initializes UI components, and exposes functions
// on window.bms for the pre bundle to access.

var input = document.getElementById("searchInput");
const ENTER_SUBMIT_DEBOUNCE_MS = 700;
let lastEnterSubmitTs = 0;

import {
    getAppliedPubYearRange,
    getPubTypeValues,
    getPubYearDefaults,
    getSavedCheckboxStates,
    getSavedPubYearRange,
    isAnyFilterApplied,
    setAppliedPubYearRange,
    setPubTypeValues,
    setSavedCheckboxStates,
    setSavedPubYearRange
} from "../state/filters.js";
import { initFilters } from "../ui/filters.js";
import { initSearchbox, adjustTextareaHeight, hideExampleStrip } from "../ui/searchbox.js";
import { initScrollToBottom } from "../ui/scroll.js";

function bmsCall(fnName, ...args) {
    console.log('[bmsCall] Calling function:', fnName, 'with args:', args);
    try {
        const fn = window.bms && window.bms[fnName];
        if (typeof fn === 'function') {
            console.log('[bmsCall] Function found, calling it');
            const result = fn(...args);
            console.log('[bmsCall] Function called, result:', result);
            return result;
        } else {
            console.warn('[bmsCall] Function not found:', fnName, 'window.bms:', window.bms);
        }
    } catch (e) {
        console.error('[bmsCall] Error calling function:', fnName, e);
        // ignore
    }
    return null;
}

// Execute a function when the user presses a key on the keyboard
input.addEventListener("keypress", function(event) {
    // If the user presses the "Enter" key on the keyboard
    if (event.key === "Enter" && !event.shiftKey) {
        const now = Date.now();
        if (now - lastEnterSubmitTs < ENTER_SUBMIT_DEBOUNCE_MS) {
            event.preventDefault();
            return;
        }
        // Check if input is not empty before proceeding
        if (!input.value.trim()) {
            return;
        }
    lastEnterSubmitTs = now;
    // Cancel the default action, if needed
    event.preventDefault();
    // Trigger the button element with a click
    bmsCall('handleSearch');
    }
});

document.querySelectorAll('.chip').forEach(chip => {
  chip.addEventListener('click', async () => {
    const value = chip.getAttribute('data-value');
    const allowed = await bmsCall('checkSearchLimit');
    if (!allowed) return;
    document.getElementById('searchInput').value = value;
    bmsCall('handleSearch');
  });
});

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
    const newColorScheme = event.matches ? "dark" : "light";
    if (newColorScheme === "dark") {
    document.getElementById("logo").src = "/static/img/icon-darkmode.png";
    } else {
    document.getElementById("logo").src = "/static/img/icon.png";
    }
});
if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    document.getElementById("logo").src = "/static/img/icon-darkmode.png";
} else {
    document.getElementById("logo").src = "/static/img/icon.png";
}

// Textarea/searchbox UI initialization (moved to ui module)
initSearchbox();

// Expose functions on window.bms for pre bundle access
window.bms = window.bms || {};
window.bms.adjustTextareaHeight = adjustTextareaHeight;
window.bms.hideExampleStrip = hideExampleStrip;
if (window.bms.adjustTextareaHeight) {
    window.adjustTextareaHeight = window.bms.adjustTextareaHeight;
}
if (window.bms.hideExampleStrip) {
    window.hideExampleStrip = window.bms.hideExampleStrip;
}

// Filter modal wiring (moved to ui module)
initFilters();

// Scroll to bottom button functionality (moved to ui module)
initScrollToBottom();
